import React, { useState, useEffect } from "react";
import { Table, Button, Row, Col, Card, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { deleteCategory, getCategories } from "../../../../services/CategoryService";
import {
  DatatableWrapper,
  TableBody,
  TableHeader,
  PaginationOptions,
  Pagination,
} from "react-bs-datatable";

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const data = await getCategories();
      setCategories(data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteCategory(id);
      fetchCategories(); // Refresh list after deletion
      console.log("Category deleted successfully");
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  // Table headers for the datatable
  const header = [
    { prop: "name", title: "Name" },
    {
      prop: "actions",
      title: "Actions",
      cell: (row) => (
        <>
          <Link
            to={`/settings/skillcategory/edit/${row._id}`}
            variant="primary"
            className="btn btn-primary shadow btn-xs sharp me-1"
          >
            <i className="fa fa-pencil"></i>
          </Link>
          <Button
            variant="danger"
            className="btn btn-danger shadow btn-xs sharp me-1"
            onClick={() => handleDelete(row._id)}
          >
            <i className="fa fa-trash"></i>
          </Button>
        </>
      ),
    },
  ];

  // Format data for the table
  const tableData = categories.map((category) => ({
    name: category.name.toUpperCase(),
    _id: category._id, // Include for delete/edit actions
  }));

  // Filter the data based on the category name
  const filteredData = tableData.filter(
    (item) => item.name && item.name.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <Card>
      <div className="card-body">
        <Row>
          <Col xs={12}>
            <h4>Category List</h4>
            <Link
              variant="primary"
              to={"/settings/skillcategory/add"}
              className="mb-4 d-flex justify-content-end"
            >
              <Button>Add Category</Button>
            </Link>

            <DatatableWrapper
              body={filteredData} // Use filtered data for the table
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 5, // Set rows per page
                  options: [5, 10, 15], // Options for rows per page
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Form.Control
                    type="text"
                    placeholder="Search by Category Name"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </Col>
              </Row>

              <Table>
                <TableHeader />
                <TableBody />
              </Table>

              <Row>
                <Col className="d-flex flex-col justify-content-start">
                  <PaginationOptions />
                </Col>
                <Col className="mt-4 d-flex  justify-content-end align-items-end">
                  <Pagination />
                </Col>
              </Row>
            </DatatableWrapper>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default CategoryList;
